import device from 'current-device';
import {EBreakpoint} from '@/common/scripts/constants';
import type {IDynamicImport} from '@/common/scripts/types/utils';
import type {IYandexMap} from '@/components/yandex-map/types';
import {Utils} from '@/common/scripts/utils';

let contactsMap: HTMLElement | null = null;
let yandexMap: IYandexMap;

const bindEvents = (): void => {
    if (!contactsMap) {
        return;
    }

    const infoItems = [...contactsMap.querySelectorAll('.j-contacts-item')] as HTMLElement[];

    infoItems.forEach((item: HTMLElement) => {
        item.addEventListener('mouseenter', () => {
            if (!device.desktop()) {
                return;
            }

            const id = item.dataset['id'];
            const marker = contactsMap?.querySelector(`.j-yandex-map-marker[data-id="${id}"]`) as HTMLElement;

            if (marker) {
                marker.classList.add('is-hover');

                // @ts-ignore
                if (!Utils.isInBlockViewport(contactsMap, marker)) {
                    const coords = JSON.parse(marker.dataset['coords'] || '[]');

                    yandexMap?.panTo(coords);
                }
            }
        });

        item.addEventListener('mouseleave', () => {
            if (!device.desktop()) {
                return;
            }

            const id = item.dataset['id'];
            const marker = contactsMap?.querySelector(`.j-yandex-map-marker[data-id="${id}"]`);

            if (marker) {
                marker.classList.remove('is-hover');
            }
        });

        item.addEventListener('click', () => {
            if (device.desktop()) {
                return;
            }

            const id = item.dataset['id'];
            const marker = contactsMap?.querySelector(`.j-yandex-map-marker[data-id="${id}"]`) as HTMLElement;
            const infoBlock = contactsMap?.querySelector(`.j-contacts-item[data-id="${id}"]`) as HTMLElement;
            const markers = [...document.querySelectorAll('.j-yandex-map-marker')] as HTMLElement[];

            markers.forEach((markerItem: HTMLElement) => {
                markerItem.classList.remove('is-hover');
            });

            infoItems.forEach((infoItem: HTMLElement) => {
                infoItem.classList.remove('is-hover');
            });

            if (marker) {
                marker.classList.add('is-hover');
                infoBlock.classList.add('is-hover');

                if (window.innerWidth >= EBreakpoint.TABLET) {
                    // @ts-ignore
                    if (!Utils.isInBlockViewport(contactsMap, marker, 500)) {
                        const coords = JSON.parse(marker.dataset['coords'] || '[]');

                        yandexMap?.panTo([coords[0], coords[1] - 0.005]);
                    }
                } else {
                    const coords = JSON.parse(marker.dataset['coords'] || '[]');

                    yandexMap?.panTo(coords);
                }
            }
        });
    });
};

const initProjectsMap = (): void => {
    if (!contactsMap) {
        return;
    }

    const ymaps = window.ymaps;

    if (ymaps) {
        ymaps.ready(() => {
            import(/* webpackChunkName: "yandex-map" */ '@/components/yandex-map')
                .then(({default: YandexMap}: IDynamicImport) => {
                    if (contactsMap === null) {
                        return;
                    }

                    yandexMap = new YandexMap(ymaps);

                    yandexMap.init({
                        wrapper                : contactsMap,
                        cluster                : false,
                        fullScreenControl      : false,
                        customFullScreenControl: false,
                        customZoomControl      : true,
                        disableMobileDrag      : true
                    });
                });
        });
    }

    bindEvents();
};

const initContactsMap = (locationWrapper: HTMLElement): void => {
    contactsMap = locationWrapper;

    Utils.checkMap(initProjectsMap);
};

export default initContactsMap;
